import type { ICreatorSummary } from "@/pages/CreatorAnalytics/types";

import type { ISummaryCardProps } from "../components/SummaryCard";
import { formatNumber } from "./formatNumber";
import { formatRatingPercent } from "./formatRatingPercent";

export const buildSummaryCards = (summary: ICreatorSummary, isFavoritesAvailable: boolean): ISummaryCardProps[] => [
  { label: "Total Requests", value: formatNumber(summary.totalRequests), accent: "blue" },
  { label: "Unique Users", value: formatNumber(summary.uniqueUsers), accent: "purple" },
  { label: "Conversations", value: formatNumber(summary.uniqueConversations), accent: "blue" },
  { label: "Active Characters", value: String(summary.activeCharacters), accent: "purple" },
  {
    label: "Avg Depth",
    value: summary.avgDepth.toFixed(1),
    subtext: `${summary.avgRequestsPerConversation.toFixed(1)} req/conv`,
    accent: "orange",
  },
  {
    label: "Avg Rating",
    value: formatRatingPercent(summary.avgRating),
    subtext: `${formatNumber(summary.ratingsCount)} ratings`,
    accent: "green",
  },
  {
    label: "Net Likes",
    value: isFavoritesAvailable ? formatNumber(summary.netLikes) : "N/A",
    subtext: isFavoritesAvailable
      ? `+${formatNumber(summary.totalLikes)} / -${formatNumber(summary.totalUnlikes)}`
      : `Available from ${summary.favoritesAvailableFrom}`,
    accent: "green",
  },
];
